// extracted by mini-css-extract-plugin
export default {"Icon":"Debugger_Icon__6bT76","IconClickable":"Debugger_IconClickable__iO1mY","Pre":"Debugger_Pre__qtRm5"};